export const EDUCATION_OPTIONS = [
	{ value: 'bachelor', label: 'Lisans mezunuyum' },
	{ value: 'master', label: 'Yüksek Lisans mezunuyum' },
	{ value: 'ongoing_master', label: 'Yüksek Lisansa devam ediyorum' }
];

export const EDUCATION_LEVELS: any = {
	bachelor: 1,
	bachelorDegree: 1,
	master: 2,
	masterDegree: 2,
	ongoing_master: 4,
	studentCertificate: 4
} as const;

export const EDUCATION_LEVEL_MAP: any = {
	bachelor: 'UNDERGRADUATE_DEGREE',
	master: 'POSTGRADUATE_DEGREE',
	ongoing_master: 'ONGOING_POSTGRADUATE'
};
